export const SEARCH_COOKIE = 'ha-trip-prst';



// WEBPACK FOOTER //
// ./src/universal/config/constants.js